<div style="width: 100%; height: 100%; display: flex">
  <!-- PICTURE -->
  @if (!$isMobile()) {
    <div class="background-picture"></div>
  }
  <div class="connection-container">
    <div class="form-card">
      <div class="connection-logo" alt="Logo Coyote Fleet Connect"></div>

      <div class="container-header">
        <p class="title">{{ 'USER.CHANGEYOURPASSWORD' | translate }}</p>
        @if (passwordForceChange) {
          <p class="subtitle">{{ 'USER.PASSWORDEXPIRED' | translate }}</p>
        }
      </div>

      <!-- FORM -->
      <form id="passwordForm" [formGroup]="passwordForm" class="form-container" (ngSubmit)="onSubmit()">
        <!-- NEW PASSWORD -->
        <mat-form-field appearance="outline" color="accent">
          <mat-label>{{ 'CONNECTION.NEWPASSWORD' | translate }}</mat-label>
          <input matInput [type]="hide ? 'password' : 'text'" formControlName="password" />
          <mat-icon matSuffix (click)="hide = !hide">
            {{ hide ? 'visibility_off' : 'visibility' }}
          </mat-icon>
          <mat-hint align="end">{{ password.value.length || 0 }}/50</mat-hint>
          @if (password.invalid && (password.dirty || password.touched)) {
            <mat-error>
              @if (password.hasError('minlength')) {
                <span>{{ 'CONNECTION.PASSWORDMIN' | translate }}</span>
              }
              @if (password.hasError('maxlength')) {
                <span>{{ 'CONNECTION.PASSWORDMAX' | translate }}</span>
              }
            </mat-error>
          }
        </mat-form-field>

        <!-- CONFIRM NEW PASSWORD -->
        <mat-form-field appearance="outline" color="accent">
          <mat-label>{{ 'CONNECTION.CONFIRMNEWPASSWORD' | translate }}</mat-label>
          <input matInput [type]="hideConfirm ? 'password' : 'text'" formControlName="passwordConfirm" />
          <mat-icon matSuffix (click)="hideConfirm = !hideConfirm">
            {{ hideConfirm ? 'visibility_off' : 'visibility' }}
          </mat-icon>
          <mat-hint align="end">{{ passwordConfirm.value.length || 0 }}/50</mat-hint>
          @if (passwordConfirm.invalid && (passwordConfirm.dirty || passwordConfirm.touched)) {
            <mat-error>
              @if (passwordConfirm.hasError('minlength')) {
                <span>{{ 'CONNECTION.PASSWORDMIN' | translate }}</span>
              }
              @if (passwordConfirm.hasError('maxlength')) {
                <span>{{ 'CONNECTION.PASSWORDMAX' | translate }}</span>
              }
            </mat-error>
          }
        </mat-form-field>

        <!-- FORM errors -->
        @if (passwordForm.hasError('passInvalid') && (password.dirty || password.touched)) {
          <mat-error>
            <span class="error">{{ 'USER.INVALIDPASSWORD' | translate }}</span>
          </mat-error>
        }
        @if (passwordForm.hasError('passError') && (passwordConfirm.dirty || passwordConfirm.touched)) {
          <mat-error>
            <span class="error">{{ 'CONNECTION.SAMEPASSWORD' | translate }}</span>
          </mat-error>
        }
      </form>
      <!-- ACTIONS -->
      <div class="container-actions">
        <button matButton="outlined" color="primary" (click)="logout()">
          {{ 'COMMON.CANCEL' | translate }}
        </button>
        <button
          form="passwordForm"
          type="submit"
          matButton="filled"
          color="accent"
          [disabled]="passwordForm.invalid">
          {{ 'COMMON.SAVE' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
